





































































import Component from 'vue-class-component'
import Vue from 'vue'
import RespondecoFormGroup from '@/shared/components/respondeco-form-group.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import RespondecoValidationFeedback from '@/shared/components/respondeco-validation-feedback.vue'
import UnifyTextarea from '@/shared/components/unify/unify-textarea.vue'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import RespondecoImage from '@/shared/components/respondeco-image.vue'
import RespondecoBackgroundImage from '@/shared/components/respondeco-background-image.vue'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import RespondecoResourceChooser from '@/shared/components/respondeco-resource-chooser.vue'
import RespondecoCategories from '@/shared/components/respondeco-categories.vue'

@Component({
  name: 'new-project-basics',
  components: {
    RespondecoCategories,
    RespondecoResourceChooser,
    UnifyButton,
    RespondecoBackgroundImage,
    RespondecoImage,
    UnifyList,
    UnifyTextarea,
    RespondecoValidationFeedback,
    UnifyFormInput,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    RespondecoFormGroup,
  },
})
export default class NewProjectBasics extends Vue {}
